/**
 * Created by jv on 2019-09-10 (14:32).
 */
const log = require("Sources/utils/logger")();
import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/game/quiz.html";
import LanguageManager from "Sources/services/language-manager";
import utils from "Sources/utils/utils";
import ScoreScreen from "Sources/components/game/components/score-screen";

require("Styles/components/views/quiz.scss");

class QuizView extends GameView {
  constructor(options) {
    options.html = $(htmlView);
    super(options);

    this.path = "quiz";

    this.gameSession = options.gameSession;
    this.questions = options.questions;
    this.currentQuestion = utils.isNumber(options.currentQuestion) ? options.currentQuestion : 0;

    this.onQuestionAnswered = options.onQuestionAnswered;
  }

  render() {
    super.render();

    this.$scoreScreenContainer = this.$element.find(".quiz-result-wrapper");

    this.renderQuestions();
    this.renderScoreScreen();
    this._setUpEventListeners();

    this.onRender();
  }

  renderScoreScreen() {
    if (utils.isNotNull(this.scoreScreen)) {
      this.scoreScreen.destroy();
    }

    this.scoreScreen = new ScoreScreen({
      container: this.$scoreScreenContainer,
      title: LanguageManager.getValueForKey("serious_game.quiz.result.title"),
      mode: "quiz",
      team: this.gameSession.team,
      teams: this.gameSession.teamList
    });

    this.scoreScreen.render();

    this.scoreScreen.hideWaitingIndicators();
  }

  renderQuestions() {
    this.$questionsWrapper = this.$element.find(".questions-wrapper");
    let foundStartQuestion = false;

    for (let i = 0; i < this.questions.length; i++) {
      let $questionWrapper = QuizView.renderQuestion(this.questions[i]);
      $questionWrapper.hide();

      if (i === this.currentQuestion) {
        foundStartQuestion = true;
        $questionWrapper.show();
      }

      this.$questionsWrapper.append($questionWrapper);
    }

    if (!foundStartQuestion) {
      this.$questionsWrapper.find(".question-wrapper").first().show();
    }
  }

  static renderQuestion(question) {
    let $questionWrapper = $("<div class='question-wrapper'></div>");
    $questionWrapper.data("question-index", question.index);
    $questionWrapper.append(`<h5 class='question-title'>${question.question}</h5>`);

    let $row = $("<div class='row answer-row'></div>");
    let $column1 = $("<div class='col-12 col-md-6'></div>").append(QuizView.renderAnswer(question.index, question.correctimage, question.correcttext, true));
    let $column2 = $("<div class='col-12 col-md-6'></div>").append(QuizView.renderAnswer(question.index, question.wrongimage, question.wrongtext, false));

    let random = utils.getRandomIntInclusive(1, 2);

    if (random === 1) {
      $row.append($column1).append($column2);
    } else {
      $row.append($column2).append($column1);
    }

    $questionWrapper.append($row);

    return $questionWrapper;
  }

  static renderAnswer(index, image, text, isCorrect) {
    let $answer = $("<div class='answer-wrapper'></div>");
    let $answerImageWrapper = $("<div class='answer__image-wrapper'></div>");
    $answerImageWrapper.append(`<img src="${image}" alt="${text}"/>`);
    $answer.append($answerImageWrapper);

    let $answerButtonWrapper = $("<div class='answer__button-wrapper'></div>");
    let $answerBtn = $(`<button class='btn btn-c-light-blue btn-lg quiz__answer-btn' type='button'>${text}</button>`);

    $answerBtn.data("question-index", index);
    $answerBtn.data("question-result", isCorrect ? 1 : 0);

    $answerButtonWrapper.append($answerBtn);
    $answer.append($answerButtonWrapper);

    return $answer;
  }

  setCurrentQuestion(currentQuestionIndex) {
    this.$element.find(".quiz-waiting__loader").hide();

    this.$questionsWrapper.find(".question-wrapper").each((index, el) => {
      let $questionWrapper = $(el);
      let questionIndex = $questionWrapper.data("question-index");

      if (currentQuestionIndex === questionIndex) {
        this.currentQuestion = index;
        $questionWrapper.find(".quiz__answer-btn").removeClass("btn-loading").prop("disabled", false);
        $questionWrapper.show();
      } else {
        $questionWrapper.hide();
      }
    });
  }

  showWaitingScreen() {
    this.$element.find(".quiz-waiting__loader").show();
  }

  hideScoreScreen() {
    this.scoreScreen.hide();
    this.$scoreScreenContainer.hide();

    this.$element.find(".questions-wrapper").show();
  }

  showScoreScreen(options) {
    let currentTeam = options.currentTeam,
      roundOverview = options.roundOverview;

    this.scoreScreen.roundIndex = options.roundIndex;
    this.scoreScreen.team = currentTeam;
    this.scoreScreen.roundOverview = roundOverview;

    this.$element.find(".quiz-waiting__loader").hide();
    this.$element.find(".questions-wrapper").hide();

    this.$scoreScreenContainer.show();
    this.scoreScreen.show();
  }

  updateScoreScreen(options) {
    let currentTeam = options.currentTeam,
      roundOverview = options.roundOverview;

    this.scoreScreen.roundIndex = options.roundIndex;
    this.scoreScreen.team = currentTeam;
    this.scoreScreen.roundOverview = roundOverview;
    this.scoreScreen.update();
  }

  updateTeamList(teamList) {
    this.gameSession.teamList = teamList;

    if (utils.isNotNull(this.scoreScreen)) {
      this.scoreScreen.updateTeamList(teamList);
    }
  }

  _setUpEventListeners() {
    this.$questionsWrapper.find(".quiz__answer-btn").off("click").on("click", (e) => {
      let $this = $(e.delegateTarget);
      let questionIndex = $this.data("question-index");

      if (questionIndex !== this.currentQuestion) {
        log.error("Unexpected question order. Expected to get answer for question %d - but got answer for question %d instead", this.currentQuestion, questionIndex);
      } else {
        $this.closest(".question-wrapper").find(".quiz__answer-btn").addClass("btn-loading").prop("disabled", true);

        let questionResult = $this.data("question-result");

        if (utils.isFunction(this.onQuestionAnswered)) {
          this.onQuestionAnswered.call(this, questionIndex, questionResult === 1);
        }
      }
    });
  }
}

module.exports = QuizView;



// WEBPACK FOOTER //
// ./app/js/components/game/views/quiz.js